import {defineMessages} from 'react-intl';

const messages = defineMessages({
	itemCounts: {
		id: 'global.itemCounts',
		defaultMessage: `{total, plural,
			=0 {no content}
			other {}
		}{collections, plural,
			=0 {}
			one {one collection}
			other {{collections} collections}
		}{both, select,
			true {, }
			other {}
		}{stories, plural,
			=0 {}
			one {one story}
			other {{stories} stories}
		}`,
	},
});

export default messages;



// WEBPACK FOOTER //
// ./lib/components/globallocales.js